<template>
    <div>
        <v-toolbar>
            <v-btn icon @click="goBack">
                <v-icon>fas fa-arrow-left</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <div style="padding-left: 30px;">
                <v-select :items="userOptions" v-model="brukerFilter"></v-select>
            </div>
            <div style="padding-right: 30px;">Folder: <v-select @change="getData" :items="[
                {text:'Alt', value:null},
                {text:'Ecommerce', value:'IEAARZFPI4BSEG5W'},
                {text:'Report', value:'IEAARZFPI4Z7I2DL'}
            ]" v-model="folder"></v-select></div>
            <v-toolbar-title @dblclick="editDate = true">
                <v-menu v-model="editDate">
                    <template v-slot:activator="{ on, attrs }">
                        <span class="ma-3">Måned: {{ start.format('MMMM YYYY') }}</span>
                        <button @click="downloadTable">
                            <v-icon>fas fa-download</v-icon>
                        </button>
                    </template>
                    <v-date-picker type="month" :value="start.format('YYYY-MM-DD')" @change="changeStartDate"></v-date-picker>
                </v-menu>

                <div :title="'Oppdatert ' + loadDateFromNow">
                    Oppdatert {{ loadDateFromNow }}
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <button v-bind="attrs" v-on="on" class="fas fa-redo" :class="loading ? 'fa-spin' : ''" @click="getData(true)"></button>
                        </template>
                        <span>Oppdater</span>
                    </v-tooltip>
                </div>
            </v-toolbar-title>

            <div style="padding-left: 30px;">
                Sum timer: {{timelogs.reduce((sum, i) => { sum += i.hours; return sum}, 0.0)}}<br>
                Antall rader: {{timelogs.length}} <br>
                Trenger validering: {{timelogs.filter(i => {return isAfterEndTime(i.createdDate) }).length }}
            </div>

            <div style="padding-left: 30px;">
                <v-text-field placeholder="Filter" v-model="filter"></v-text-field>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon @click="goForward">
                <v-icon>fas fa-arrow-right</v-icon>
            </v-btn>
        </v-toolbar>
        <div class="table-wrapper clusterize-scroll" id="scrollArea">
            <table class="data">
                <thead>
                <tr>
                    <th>Dato</th>
                    <th>Avdeling</th>
                    <th>Bruker</th>
                    <th>Timer</th>
                    <th>Oppgave</th>
                    <th style="min-width: 20%;">Kommentar</th>
                    <th>Type</th>
                    <th>Kunde</th>
                    <th>Mapper</th>
                    <th>Overmapper</th>
                    <th>Status</th>
                    <th>Link</th>
                    <th>Index</th>
                    <th>Id</th>
                    <th>Created</th>
                    <th>Updated</th>
                    <th>Trenger validering!</th>
                    <th>Kort info om oppgaven</th>
                </tr>
                </thead>
                <tbody id="contentArea" class="clusterize-content">
                <tr v-for="(tl, index) in filteredTimelogs" :key="tl.id">
                    <td>{{ tl.trackedDate | date }}</td>
                    <td><span v-if="tl.user && tl.user.info">{{ tl.user.info.department }}</span></td>
                    <td v-if="tl.user" class="text-center">
                        <v-avatar><img :src="tl.user.avatarUrl" :alt="tl.user.firstName + ' ' + tl.user.lastName" ></v-avatar><br>
                        {{ tl.user.firstName }} {{ tl.user.lastName }}
                    </td>
                    <td style="color:transparent;">
                        <v-text-field :loading="tl.loading" v-model="tl.hours" @blur="saveTimelog(tl)"></v-text-field>
                        <span style="font-size:0px;">{{ tl.hours | hours }}</span>
                    </td>
                    <td>{{ getTask(tl.taskId).title }}</td>
                    <td style="color:transparent;" width="20%">
                        <v-textarea :loading="tl.loading" v-model="tl.comment" auto-grow @blur="saveTimelog(tl)"></v-textarea>
                        <span v-html="tl.comment" style="font-size:0px;"></span>
                    </td>
                    <td :style="{color:getTaskColor(getTaskType(tl.taskId))}"><v-select :loading="getTask(tl.taskId).loading" :items="taskTypes" :value="getTaskType(tl.taskId)" @change="saveTask(tl.taskId, $event)"></v-select></td>
                    <td>{{ getTask(tl.taskId).title | prefix }}</td>
                    <td>
                        <template v-for="fId in getTask(tl.taskId).parentIds" :title="fId">{{ getFolder(fId).title }}<br></template>
                    </td>
                    <td>
                        <template v-for="fId in getTask(tl.taskId).superParentIds" :title="fId">{{ getFolder(fId).title }}<br></template>
                    </td>
                    <td>{{getTask(tl.taskId).status}}</td>
                    <td>{{getTask(tl.taskId).permalink}}</td>
                    <td>{{ index }}</td>
                    <td>{{ tl.id }}</td>
                    <td :class="{'red':isAfterEndTime(tl.createdDate)}">{{ tl.createdDate | dateTime}}</td>
                    <td>{{ tl.updatedDate | dateTime}}</td>
                    <td>{{isAfterEndTime(tl.createdDate) ? 'ja' : 'nei'}}</td>
                    <td v-if="!tl.user">{{ tl.userId }}</td>
                    <td style="width:200px;word-break: break-word" v-html="getTask(tl.taskId).briefDescription"></td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import tasksMixin from '@/mixins/tasks'
import moment from "moment"
import api from "../api"
import Clusterize from 'clusterize.js'
export default {
    name: 'Invoice',
    mixins: [tasksMixin],
    data(){
        return {
            start: moment().startOf('month'),
            end: moment().startOf('month').add(1, 'month'),
            loaded: '',
            loading: false,
            timelogs:[],
            users: {},
            editDate: false,
            folder: null,
            filter: "",
            brukerFilter: null,
            clusterize: null,
        }
    },
    filters: {
        hours: function (h){
            if(h) {
                h= h.toString(); return h.replace(".", ",")
            }
            else return h
        },
        prefix: function(p){
            if(p) p=p.toString()
            else p = ''

            if(p.indexOf('-') > -1) {
                let key = p.split('-')[0]
                if((/[a-z]/.test(key)) && key.length > 10) return ''
                else return key
            }
            else return ''
        },
        date: function (d){
            if(d) return moment(d).format("DD.MM.YYYY")
            return d
        },
        dateTime: function(dt){
            if(dt) return moment(dt).format("DD.MM.YYYY HH:mm:ss")
            return dt
        }
    },
    computed: {
        loadDateFromNow(){
            if(!this.loaded) return null
            return moment(this.loaded, "DD.MM.YYYY HH:mm:ss").fromNow()
        },
        filteredTimelogs(){
            if(!this.timelogs) return []

            let timelogs = this.timelogs
            if(this.filter.length > 0){
                timelogs = timelogs.filter(tl => this.getTask(tl.taskId).title.startsWith(this.filter))
            }

            if(this.brukerFilter != null){
                timelogs = timelogs.filter(tl => tl.user.id == this.brukerFilter)
            }
            setTimeout(()=> {
                this.clusterize.update()
            }, 1000)
            return timelogs
        },
        userOptions(){
            let userKeys = Object.keys(this.users)
            let users = [{value:null, text: "Alle"}]
            for(let key in userKeys){
                if(this.users[userKeys[key]] && this.users[userKeys[key]].timelogs.length > 0) {
                    users.push({value: userKeys[key], text: `${this.users[userKeys[key]].firstName} ${this.users[userKeys[key]].lastName}`})
                }
            }
            return users;
        }
    },
    methods: {
        isAfterEndTime(time){
            moment(time).isAfter(this.end)
        },
        saveTimelog(timelog){
            timelog.loading = true
            api.PUT('/hours/' + timelog.id, {hours:timelog.hours, comment:timelog.comment})
                .then(data => {
                    console.log("success")
                }).finally(() => timelog.loading = false)
        },
        saveTask(id, type){
            let task = this.getTask(id)
            task.loading = true
            let currentType = this.getTaskType(id)
            if(currentType != type){
                api.PUT('/tasks/' + id, {customFields: JSON.stringify([{id: "IEAARZFPJUAAA6YZ", value: type}])})
                    .then(data => {
                        let element = data.data[0]
                        element.loaded = new Date()
                        this.$set(this.tasks, element.id, element)

                    }).finally(() => task.loading = false)
            }
        },
        downloadTable(){
            let csv = []
            let rows = document.querySelectorAll("table.data tr")

            for(let i = 0; i < rows.length; i++){
                let row = [], cols = rows[i].querySelectorAll("td, th")
                for(let j = 0; j < cols.length; j++){
                    // Clean innertext to remove multiple spaces and jumpline (break csv)
                    let data = cols[j].innerText.replace(/(\s\s)\n\r/gm, ' ')
                    // replace new lines in Mapper and Overmapper fields.
                    if(j != 4 && data) data = data.replace(/\n/gm, ', ')
                  if(data && data.startsWith(", ")) data = data.substr(2)
                    // Escape double-quote with double-double-quote (see https://stackoverflow.com/questions/17808511/properly-escape-a-double-quote-in-csv)
                    data = data.replace(/"/g, '""')
                    // Push escaped string
                    row.push('"' + data + '"')
                }
                csv.push(row.join(","))
            }

            // Appending UTF-8 BOM https://stackoverflow.com/questions/17879198/adding-utf-8-bom-to-string-blob
            // So it is possible to open in excel directly: https://stackoverflow.com/questions/1241220/generating-csv-file-for-excel-how-to-have-a-newline-inside-a-value/1525800
            let csvFile = new Blob(['\ufeff' + csv.join("\n")], {type: "text/csv"})
            let downloadLink

            // Download link
            downloadLink = document.createElement("a")

            // File name
            downloadLink.download = this.start.format("YYYY-MMM") + "csv"

            // Create a link to the file
            downloadLink.href = window.URL.createObjectURL(csvFile)

            // Hide download link
            downloadLink.style.display = "none"

            // Add the link to DOM
            document.body.appendChild(downloadLink)

            // Click download link
            downloadLink.click()

        },
        changeStartDate(event){
            this.editDate = false
            this.start = moment(event, 'YYYY-MM-DD').startOf('month')
            this.end = this.start.clone().add(1, 'month')
            this.getData()
        },
        goForward(){
            this.start.add(1, 'month')
            this.end.add(1, 'month')
            this.getData()
        },
        goBack(){
            this.start.subtract(1, 'month')
            this.end.subtract(1, 'month')
            this.getData()
        },
        getData(refresh){
            let url = "/invoice/"
            url += "?start=" + this.start.format("DD.MM.YYYY")
            url += "&end=" + this.end.format("DD.MM.YYYY")
            if(this.folder) url += "&folder=" + this.folder
            if(refresh) localStorage.removeItem(url)
            this.loading = true
            api.GET(url)
                .then(data => {
                    this.users = {}
                    for(let i in data.users){
                        let user = data.users[i]
                        user.timelogs = []
                        this.$set(this.users, user.id, user)
                    }

                    for(let i in data.timelogs){
                        let timelog = data.timelogs[i]
                        let user = this.users[timelog.userId]
                        if(user){
                            timelog.user = user
                            user.timelogs.push(timelog)
                        }
                    }

                    this.getMissingTasks(data.timelogs, refresh)
                    this.timelogs = data.timelogs
                    this.loaded = data.loaded
                }).finally(() => this.loading = false)
        }
    },
    created(){
        this.getData()
    },
    mounted(){
        this.$nextTick(() => {
            this.clusterize = new Clusterize({
                scrollId: 'scrollArea',
                contentId: 'contentArea'
            })
        })
    }
}
</script>
<style scoped>
.red{
    background-color: red;
}
.table-wrapper {
    overflow-x: auto;
}

td, th {
    padding: 20px;
    font-size: 12px;
    border-bottom: 1px solid gray;
    border-right: 1px solid gray;
}
</style>